'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _templateObject = _taggedTemplateLiteral(['\n        width: 60px;\n        height: 60px;\n    '], ['\n        width: 60px;\n        height: 60px;\n    ']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactBodymovin = require('react-bodymovin');

var _reactBodymovin2 = _interopRequireDefault(_reactBodymovin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var unfavoritingAnimation = {
    v: '5.1.1',
    fr: 29.9700012207031,
    ip: 0,
    op: 50.0000020365418,
    w: 50,
    h: 50,
    nm: 'Affordable-AE',
    ddd: 0,
    assets: [],
    layers: [{
        ddd: 0,
        ind: 1,
        ty: 4,
        nm: 'Coin Slot Outlines',
        sr: 1,
        ks: {
            o: {
                a: 0,
                k: 100,
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [25, 25, 0],
                ix: 2
            },
            a: {
                a: 0,
                k: [25, 25, 0],
                ix: 1
            },
            s: {
                a: 0,
                k: [100, 100, 100],
                ix: 6
            }
        },
        ao: 0,
        shapes: [{
            ty: 'gr',
            it: [{
                ind: 0,
                ty: 'sh',
                ix: 1,
                ks: {
                    a: 0,
                    k: {
                        i: [[0, 0]],
                        o: [[0, 0]],
                        v: [[31.881, 21.057]],
                        c: true
                    },
                    ix: 2
                },
                nm: 'Path 1',
                mn: 'ADBE Vector Shape - Group',
                hd: false
            }, {
                ty: 'st',
                c: {
                    a: 0,
                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
                    ix: 3
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 4
                },
                w: {
                    a: 0,
                    k: 1,
                    ix: 5
                },
                lc: 2,
                lj: 2,
                nm: 'Stroke 1',
                mn: 'ADBE Vector Graphic - Stroke',
                hd: false
            }, {
                ty: 'tr',
                p: {
                    a: 0,
                    k: [0, 0],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 6
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 7
                },
                sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                },
                nm: 'Transform'
            }],
            nm: 'Group 1',
            np: 2,
            cix: 2,
            ix: 1,
            mn: 'ADBE Vector Group',
            hd: false
        }, {
            ty: 'gr',
            it: [{
                ind: 0,
                ty: 'sh',
                ix: 1,
                ks: {
                    a: 0,
                    k: {
                        i: [[0, 0], [0, 0]],
                        o: [[0, 0], [0, 0]],
                        v: [[24.045, 21.057], [29.473, 21.057]],
                        c: false
                    },
                    ix: 2
                },
                nm: 'Path 1',
                mn: 'ADBE Vector Shape - Group',
                hd: false
            }, {
                ty: 'st',
                c: {
                    a: 0,
                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
                    ix: 3
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 4
                },
                w: {
                    a: 0,
                    k: 1,
                    ix: 5
                },
                lc: 2,
                lj: 2,
                nm: 'Stroke 1',
                mn: 'ADBE Vector Graphic - Stroke',
                hd: false
            }, {
                ty: 'tr',
                p: {
                    a: 0,
                    k: [0, 0],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 6
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 7
                },
                sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                },
                nm: 'Transform'
            }],
            nm: 'Group 2',
            np: 2,
            cix: 2,
            ix: 2,
            mn: 'ADBE Vector Group',
            hd: false
        }, {
            ty: 'gr',
            it: [{
                ind: 0,
                ty: 'sh',
                ix: 1,
                ks: {
                    a: 0,
                    k: {
                        i: [[0, 0], [0, 0], [0, 0], [0, 0]],
                        o: [[0, 0], [0, 0], [0, 0], [0, 0]],
                        v: [[4.443, 4.346], [-4.443, 4.346], [-4.443, -4.346], [4.443, -4.346]],
                        c: true
                    },
                    ix: 2
                },
                nm: 'Path 1',
                mn: 'ADBE Vector Shape - Group',
                hd: false
            }, {
                ty: 'fl',
                c: {
                    a: 0,
                    k: [1, 1, 1, 1],
                    ix: 4
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 5
                },
                r: 1,
                nm: 'Fill 1',
                mn: 'ADBE Vector Graphic - Fill',
                hd: false
            }, {
                ty: 'tr',
                p: {
                    a: 0,
                    k: [27.784, 25.403],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 6
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 7
                },
                sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                },
                nm: 'Transform'
            }],
            nm: 'Group 3',
            np: 2,
            cix: 2,
            ix: 3,
            mn: 'ADBE Vector Group',
            hd: false
        }],
        ip: 0,
        op: 899.000036617021,
        st: 0,
        bm: 0
    }, {
        ddd: 0,
        ind: 3,
        ty: 4,
        nm: 'Line Outlines',
        sr: 1,
        ks: {
            o: {
                a: 0,
                k: 100,
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [25, 25, 0],
                ix: 2
            },
            a: {
                a: 0,
                k: [25, 25, 0],
                ix: 1
            },
            s: {
                a: 0,
                k: [100, 100, 100],
                ix: 6
            }
        },
        ao: 0,
        shapes: [{
            ty: 'gr',
            it: [{
                ind: 0,
                ty: 'sh',
                ix: 1,
                ks: {
                    a: 0,
                    k: {
                        i: [[0, 0], [0, 0]],
                        o: [[0, 0], [0, 0]],
                        v: [[26.762, 14.042], [26.764, 2.584]],
                        c: false
                    },
                    ix: 2
                },
                nm: 'Path 1',
                mn: 'ADBE Vector Shape - Group',
                hd: false
            }, {
                ty: 'st',
                c: {
                    a: 0,
                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
                    ix: 3
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 4
                },
                w: {
                    a: 0,
                    k: 1,
                    ix: 5
                },
                lc: 2,
                lj: 2,
                nm: 'Stroke 1',
                mn: 'ADBE Vector Graphic - Stroke',
                hd: false
            }, {
                ty: 'tr',
                p: {
                    a: 0,
                    k: [0, 0],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 6
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 7
                },
                sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                },
                nm: 'Transform'
            }],
            nm: 'Group 1',
            np: 2,
            cix: 2,
            ix: 1,
            mn: 'ADBE Vector Group',
            hd: false
        }, {
            ty: 'tm',
            s: {
                a: 1,
                k: [{
                    i: {
                        x: [0.667],
                        y: [1]
                    },
                    o: {
                        x: [0.669],
                        y: [0.021]
                    },
                    n: ['0p667_1_0p669_0p021'],
                    t: 4,
                    s: [100],
                    e: [0]
                }, {
                    t: 19.0000007738859
                }],
                ix: 1
            },
            e: {
                a: 1,
                k: [{
                    i: {
                        x: [0.667],
                        y: [1]
                    },
                    o: {
                        x: [0.167],
                        y: [0.167]
                    },
                    n: ['0p667_1_0p167_0p167'],
                    t: 15,
                    s: [100],
                    e: [0]
                }, {
                    t: 28.0000011404634
                }],
                ix: 2
            },
            o: {
                a: 0,
                k: 0,
                ix: 3
            },
            m: 1,
            ix: 2,
            nm: 'Trim Paths 1',
            mn: 'ADBE Vector Filter - Trim',
            hd: false
        }],
        ip: 0,
        op: 899.000036617021,
        st: 0,
        bm: 0
    }, {
        ddd: 0,
        ind: 5,
        ty: 4,
        nm: 'Coin Outlines',
        sr: 1,
        ks: {
            o: {
                a: 1,
                k: [{
                    i: {
                        x: [0.833],
                        y: [0.833]
                    },
                    o: {
                        x: [0.167],
                        y: [0.167]
                    },
                    n: ['0p833_0p833_0p167_0p167'],
                    t: 0,
                    s: [0],
                    e: [100]
                }, {
                    t: 8.00000032584668
                }],
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                s: true,
                x: {
                    a: 1,
                    k: [{
                        i: {
                            x: [0.984],
                            y: [1]
                        },
                        o: {
                            x: [0.016],
                            y: [0]
                        },
                        n: ['0p984_1_0p016_0'],
                        t: 0,
                        s: [25.5],
                        e: [25.5]
                    }, {
                        t: 19.0000007738859
                    }],
                    ix: 3
                },
                y: {
                    a: 1,
                    k: [{
                        i: {
                            x: [0.808],
                            y: [0.978]
                        },
                        o: {
                            x: [0.6],
                            y: [0.017]
                        },
                        n: ['0p808_0p978_0p6_0p017'],
                        t: 0,
                        s: [16],
                        e: [38]
                    }, {
                        t: 19.0000007738859
                    }],
                    ix: 4
                }
            },
            a: {
                a: 0,
                k: [25, 25, 0],
                ix: 1
            },
            s: {
                a: 0,
                k: [100, 100, 100],
                ix: 6
            }
        },
        ao: 0,
        shapes: [{
            ty: 'gr',
            it: [{
                ind: 0,
                ty: 'sh',
                ix: 1,
                ks: {
                    a: 0,
                    k: {
                        i: [[0, -1.531], [1.53, 0], [0, 1.531], [-1.531, 0]],
                        o: [[0, 1.531], [-1.531, 0], [0, -1.531], [1.53, 0]],
                        v: [[2.771, 0], [0.001, 2.771], [-2.771, 0], [0.001, -2.771]],
                        c: true
                    },
                    ix: 2
                },
                nm: 'Path 1',
                mn: 'ADBE Vector Shape - Group',
                hd: false
            }, {
                ty: 'st',
                c: {
                    a: 0,
                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
                    ix: 3
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 4
                },
                w: {
                    a: 0,
                    k: 1,
                    ix: 5
                },
                lc: 2,
                lj: 2,
                nm: 'Stroke 1',
                mn: 'ADBE Vector Graphic - Stroke',
                hd: false
            }, {
                ty: 'fl',
                c: {
                    a: 0,
                    k: [1, 0.773000021542, 0.039000002543, 1],
                    ix: 4
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 5
                },
                r: 1,
                nm: 'Fill 1',
                mn: 'ADBE Vector Graphic - Fill',
                hd: false
            }, {
                ty: 'tr',
                p: {
                    a: 0,
                    k: [26.76, 11.985],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 6
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 7
                },
                sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                },
                nm: 'Transform'
            }],
            nm: 'Group 1',
            np: 3,
            cix: 2,
            ix: 1,
            mn: 'ADBE Vector Group',
            hd: false
        }],
        ip: 0,
        op: 899.000036617021,
        st: 0,
        bm: 0
    }, {
        ddd: 0,
        ind: 7,
        ty: 4,
        nm: 'Everything Else Outlines',
        sr: 1,
        ks: {
            o: {
                a: 0,
                k: 100,
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [25, 25, 0],
                ix: 2
            },
            a: {
                a: 0,
                k: [25, 25, 0],
                ix: 1
            },
            s: {
                a: 0,
                k: [100, 100, 100],
                ix: 6
            }
        },
        ao: 0,
        shapes: [{
            ty: 'gr',
            it: [{
                ind: 0,
                ty: 'sh',
                ix: 1,
                ks: {
                    a: 0,
                    k: {
                        i: [[0, 0], [0, 0], [0, 0], [0, 0]],
                        o: [[0, 0], [0, 0], [0, 0], [0, 0]],
                        v: [[3.125, 1.15], [-3.125, 1.15], [-3.125, -1.15], [3.125, -1.15]],
                        c: true
                    },
                    ix: 2
                },
                nm: 'Path 1',
                mn: 'ADBE Vector Shape - Group',
                hd: false
            }, {
                ty: 'st',
                c: {
                    a: 0,
                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
                    ix: 3
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 4
                },
                w: {
                    a: 0,
                    k: 1,
                    ix: 5
                },
                lc: 2,
                lj: 2,
                nm: 'Stroke 1',
                mn: 'ADBE Vector Graphic - Stroke',
                hd: false
            }, {
                ty: 'fl',
                c: {
                    a: 0,
                    k: [1, 0.773000021542, 0.039000002543, 1],
                    ix: 4
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 5
                },
                r: 1,
                nm: 'Fill 1',
                mn: 'ADBE Vector Graphic - Fill',
                hd: false
            }, {
                ty: 'tr',
                p: {
                    a: 0,
                    k: [9.762, 38.779],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 6
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 7
                },
                sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                },
                nm: 'Transform'
            }],
            nm: 'Group 1',
            np: 3,
            cix: 2,
            ix: 1,
            mn: 'ADBE Vector Group',
            hd: false
        }, {
            ty: 'gr',
            it: [{
                ind: 0,
                ty: 'sh',
                ix: 1,
                ks: {
                    a: 0,
                    k: {
                        i: [[0, 0], [0, 0], [0, 0], [0, 0]],
                        o: [[0, 0], [0, 0], [0, 0], [0, 0]],
                        v: [[3.125, 1.15], [-3.125, 1.15], [-3.125, -1.15], [3.125, -1.15]],
                        c: true
                    },
                    ix: 2
                },
                nm: 'Path 1',
                mn: 'ADBE Vector Shape - Group',
                hd: false
            }, {
                ty: 'st',
                c: {
                    a: 0,
                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
                    ix: 3
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 4
                },
                w: {
                    a: 0,
                    k: 1,
                    ix: 5
                },
                lc: 2,
                lj: 2,
                nm: 'Stroke 1',
                mn: 'ADBE Vector Graphic - Stroke',
                hd: false
            }, {
                ty: 'fl',
                c: {
                    a: 0,
                    k: [1, 0.773000021542, 0.039000002543, 1],
                    ix: 4
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 5
                },
                r: 1,
                nm: 'Fill 1',
                mn: 'ADBE Vector Graphic - Fill',
                hd: false
            }, {
                ty: 'tr',
                p: {
                    a: 0,
                    k: [9.762, 41.025],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 6
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 7
                },
                sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                },
                nm: 'Transform'
            }],
            nm: 'Group 2',
            np: 3,
            cix: 2,
            ix: 2,
            mn: 'ADBE Vector Group',
            hd: false
        }, {
            ty: 'gr',
            it: [{
                ind: 0,
                ty: 'sh',
                ix: 1,
                ks: {
                    a: 0,
                    k: {
                        i: [[0, 0], [-0.403, 0], [0, -0.404]],
                        o: [[0, -0.404], [0.404, 0], [0, 0]],
                        v: [[-0.73, 0.365], [-0.001, -0.365], [0.73, 0.365]],
                        c: false
                    },
                    ix: 2
                },
                nm: 'Path 1',
                mn: 'ADBE Vector Shape - Group',
                hd: false
            }, {
                ty: 'st',
                c: {
                    a: 0,
                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
                    ix: 3
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 4
                },
                w: {
                    a: 0,
                    k: 1,
                    ix: 5
                },
                lc: 2,
                lj: 2,
                nm: 'Stroke 1',
                mn: 'ADBE Vector Graphic - Stroke',
                hd: false
            }, {
                ty: 'tr',
                p: {
                    a: 0,
                    k: [10.637, 24.142],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 6
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 7
                },
                sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                },
                nm: 'Transform'
            }],
            nm: 'Group 3',
            np: 2,
            cix: 2,
            ix: 3,
            mn: 'ADBE Vector Group',
            hd: false
        }, {
            ty: 'gr',
            it: [{
                ind: 0,
                ty: 'sh',
                ix: 1,
                ks: {
                    a: 0,
                    k: {
                        i: [[0, 0], [-0.404, 0], [0, -0.404]],
                        o: [[0, -0.404], [0.403, 0], [0, 0]],
                        v: [[-0.73, 0.365], [0.001, -0.365], [0.73, 0.365]],
                        c: false
                    },
                    ix: 2
                },
                nm: 'Path 1',
                mn: 'ADBE Vector Shape - Group',
                hd: false
            }, {
                ty: 'st',
                c: {
                    a: 0,
                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
                    ix: 3
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 4
                },
                w: {
                    a: 0,
                    k: 1,
                    ix: 5
                },
                lc: 2,
                lj: 2,
                nm: 'Stroke 1',
                mn: 'ADBE Vector Graphic - Stroke',
                hd: false
            }, {
                ty: 'tr',
                p: {
                    a: 0,
                    k: [14.656, 24.142],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 6
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 7
                },
                sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                },
                nm: 'Transform'
            }],
            nm: 'Group 4',
            np: 2,
            cix: 2,
            ix: 4,
            mn: 'ADBE Vector Group',
            hd: false
        }, {
            ty: 'gr',
            it: [{
                ind: 0,
                ty: 'sh',
                ix: 1,
                ks: {
                    a: 0,
                    k: {
                        i: [[0, 0], [0, 0], [0, 0], [0, 0]],
                        o: [[0, 0], [0, 0], [0, 0], [0, 0]],
                        v: [[1.357, -1.001], [0.003, 1.001], [-1.357, 1.001], [-1.357, -1.001]],
                        c: true
                    },
                    ix: 2
                },
                nm: 'Path 1',
                mn: 'ADBE Vector Shape - Group',
                hd: false
            }, {
                ty: 'st',
                c: {
                    a: 0,
                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
                    ix: 3
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 4
                },
                w: {
                    a: 0,
                    k: 1,
                    ix: 5
                },
                lc: 2,
                lj: 2,
                nm: 'Stroke 1',
                mn: 'ADBE Vector Graphic - Stroke',
                hd: false
            }, {
                ty: 'fl',
                c: {
                    a: 0,
                    k: [0, 0.458999992819, 0.788000009574, 1],
                    ix: 4
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 5
                },
                r: 1,
                nm: 'Fill 1',
                mn: 'ADBE Vector Graphic - Fill',
                hd: false
            }, {
                ty: 'tr',
                p: {
                    a: 0,
                    k: [35.994, 42.174],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 6
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 7
                },
                sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                },
                nm: 'Transform'
            }],
            nm: 'Group 5',
            np: 3,
            cix: 2,
            ix: 5,
            mn: 'ADBE Vector Group',
            hd: false
        }, {
            ty: 'gr',
            it: [{
                ind: 0,
                ty: 'sh',
                ix: 1,
                ks: {
                    a: 0,
                    k: {
                        i: [[0, 0], [0, 0], [0, 0], [0, 0]],
                        o: [[0, 0], [0, 0], [0, 0], [0, 0]],
                        v: [[1.357, -1.001], [0.003, 1.001], [-1.357, 1.001], [-1.357, -1.001]],
                        c: true
                    },
                    ix: 2
                },
                nm: 'Path 1',
                mn: 'ADBE Vector Shape - Group',
                hd: false
            }, {
                ty: 'st',
                c: {
                    a: 0,
                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
                    ix: 3
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 4
                },
                w: {
                    a: 0,
                    k: 1,
                    ix: 5
                },
                lc: 2,
                lj: 2,
                nm: 'Stroke 1',
                mn: 'ADBE Vector Graphic - Stroke',
                hd: false
            }, {
                ty: 'fl',
                c: {
                    a: 0,
                    k: [0, 0.458999992819, 0.788000009574, 1],
                    ix: 4
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 5
                },
                r: 1,
                nm: 'Fill 1',
                mn: 'ADBE Vector Graphic - Fill',
                hd: false
            }, {
                ty: 'tr',
                p: {
                    a: 0,
                    k: [30.869, 42.174],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 6
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 7
                },
                sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                },
                nm: 'Transform'
            }],
            nm: 'Group 6',
            np: 3,
            cix: 2,
            ix: 6,
            mn: 'ADBE Vector Group',
            hd: false
        }, {
            ty: 'gr',
            it: [{
                ind: 0,
                ty: 'sh',
                ix: 1,
                ks: {
                    a: 0,
                    k: {
                        i: [[0, 0], [0, 0], [0, 0], [0, 0]],
                        o: [[0, 0], [0, 0], [0, 0], [0, 0]],
                        v: [[1.357, -1.001], [0.003, 1.001], [-1.357, 1.001], [-1.357, -1.001]],
                        c: true
                    },
                    ix: 2
                },
                nm: 'Path 1',
                mn: 'ADBE Vector Shape - Group',
                hd: false
            }, {
                ty: 'st',
                c: {
                    a: 0,
                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
                    ix: 3
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 4
                },
                w: {
                    a: 0,
                    k: 1,
                    ix: 5
                },
                lc: 2,
                lj: 2,
                nm: 'Stroke 1',
                mn: 'ADBE Vector Graphic - Stroke',
                hd: false
            }, {
                ty: 'fl',
                c: {
                    a: 0,
                    k: [0, 0.458999992819, 0.788000009574, 1],
                    ix: 4
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 5
                },
                r: 1,
                nm: 'Fill 1',
                mn: 'ADBE Vector Graphic - Fill',
                hd: false
            }, {
                ty: 'tr',
                p: {
                    a: 0,
                    k: [21.494, 42.174],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 6
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 7
                },
                sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                },
                nm: 'Transform'
            }],
            nm: 'Group 7',
            np: 3,
            cix: 2,
            ix: 7,
            mn: 'ADBE Vector Group',
            hd: false
        }, {
            ty: 'gr',
            it: [{
                ind: 0,
                ty: 'sh',
                ix: 1,
                ks: {
                    a: 0,
                    k: {
                        i: [[0, 0], [0, 0], [0, 0], [0, 0]],
                        o: [[0, 0], [0, 0], [0, 0], [0, 0]],
                        v: [[1.357, -1.001], [0.003, 1.001], [-1.357, 1.001], [-1.357, -1.001]],
                        c: true
                    },
                    ix: 2
                },
                nm: 'Path 1',
                mn: 'ADBE Vector Shape - Group',
                hd: false
            }, {
                ty: 'st',
                c: {
                    a: 0,
                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
                    ix: 3
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 4
                },
                w: {
                    a: 0,
                    k: 1,
                    ix: 5
                },
                lc: 2,
                lj: 2,
                nm: 'Stroke 1',
                mn: 'ADBE Vector Graphic - Stroke',
                hd: false
            }, {
                ty: 'fl',
                c: {
                    a: 0,
                    k: [0, 0.458999992819, 0.788000009574, 1],
                    ix: 4
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 5
                },
                r: 1,
                nm: 'Fill 1',
                mn: 'ADBE Vector Graphic - Fill',
                hd: false
            }, {
                ty: 'tr',
                p: {
                    a: 0,
                    k: [16.744, 42.174],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 6
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 7
                },
                sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                },
                nm: 'Transform'
            }],
            nm: 'Group 8',
            np: 3,
            cix: 2,
            ix: 8,
            mn: 'ADBE Vector Group',
            hd: false
        }, {
            ty: 'gr',
            it: [{
                ind: 0,
                ty: 'sh',
                ix: 1,
                ks: {
                    a: 0,
                    k: {
                        i: [[0, 0.377], [1.575, 0.51], [0, 0], [0, 0]],
                        o: [[0, -1.745], [0, 0], [0, 0], [0.099, -0.345]],
                        v: [[1.361, 1.286], [-1.361, -2.432], [-1.361, 2.432], [1.191, 2.366]],
                        c: true
                    },
                    ix: 2
                },
                nm: 'Path 1',
                mn: 'ADBE Vector Shape - Group',
                hd: false
            }, {
                ty: 'st',
                c: {
                    a: 0,
                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
                    ix: 3
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 4
                },
                w: {
                    a: 0,
                    k: 1,
                    ix: 5
                },
                lc: 2,
                lj: 2,
                nm: 'Stroke 1',
                mn: 'ADBE Vector Graphic - Stroke',
                hd: false
            }, {
                ty: 'fl',
                c: {
                    a: 0,
                    k: [0, 0.458999992819, 0.788000009574, 1],
                    ix: 4
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 5
                },
                r: 1,
                nm: 'Fill 1',
                mn: 'ADBE Vector Graphic - Fill',
                hd: false
            }, {
                ty: 'tr',
                p: {
                    a: 0,
                    k: [16.748, 18.95],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 6
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 7
                },
                sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                },
                nm: 'Transform'
            }],
            nm: 'Group 9',
            np: 3,
            cix: 2,
            ix: 9,
            mn: 'ADBE Vector Group',
            hd: false
        }, {
            ty: 'gr',
            it: [{
                ind: 0,
                ty: 'sh',
                ix: 1,
                ks: {
                    a: 0,
                    k: {
                        i: [[0, 0], [0, 0]],
                        o: [[0, 0], [0, 0]],
                        v: [[11.012, 29.278], [11.012, 29.125]],
                        c: false
                    },
                    ix: 2
                },
                nm: 'Path 1',
                mn: 'ADBE Vector Shape - Group',
                hd: false
            }, {
                ty: 'st',
                c: {
                    a: 0,
                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
                    ix: 3
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 4
                },
                w: {
                    a: 0,
                    k: 1,
                    ix: 5
                },
                lc: 2,
                lj: 2,
                nm: 'Stroke 1',
                mn: 'ADBE Vector Graphic - Stroke',
                hd: false
            }, {
                ty: 'fl',
                c: {
                    a: 0,
                    k: [1, 1, 1, 1],
                    ix: 4
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 5
                },
                r: 1,
                nm: 'Fill 1',
                mn: 'ADBE Vector Graphic - Fill',
                hd: false
            }, {
                ty: 'tr',
                p: {
                    a: 0,
                    k: [0, 0],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 6
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 7
                },
                sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                },
                nm: 'Transform'
            }],
            nm: 'Group 10',
            np: 3,
            cix: 2,
            ix: 10,
            mn: 'ADBE Vector Group',
            hd: false
        }, {
            ty: 'gr',
            it: [{
                ind: 0,
                ty: 'sh',
                ix: 1,
                ks: {
                    a: 0,
                    k: {
                        i: [[0, 0], [0, 0]],
                        o: [[0, 0], [0, 0]],
                        v: [[9.117, 29.278], [9.117, 29.125]],
                        c: false
                    },
                    ix: 2
                },
                nm: 'Path 1',
                mn: 'ADBE Vector Shape - Group',
                hd: false
            }, {
                ty: 'st',
                c: {
                    a: 0,
                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
                    ix: 3
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 4
                },
                w: {
                    a: 0,
                    k: 1,
                    ix: 5
                },
                lc: 2,
                lj: 2,
                nm: 'Stroke 1',
                mn: 'ADBE Vector Graphic - Stroke',
                hd: false
            }, {
                ty: 'fl',
                c: {
                    a: 0,
                    k: [1, 1, 1, 1],
                    ix: 4
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 5
                },
                r: 1,
                nm: 'Fill 1',
                mn: 'ADBE Vector Graphic - Fill',
                hd: false
            }, {
                ty: 'tr',
                p: {
                    a: 0,
                    k: [0, 0],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 6
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 7
                },
                sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                },
                nm: 'Transform'
            }],
            nm: 'Group 11',
            np: 3,
            cix: 2,
            ix: 11,
            mn: 'ADBE Vector Group',
            hd: false
        }, {
            ty: 'gr',
            it: [{
                ind: 0,
                ty: 'sh',
                ix: 1,
                ks: {
                    a: 0,
                    k: {
                        i: [[0, 0], [0, 0], [0, -2.968]],
                        o: [[0, 0], [2.969, 0], [0, 0]],
                        v: [[-2.688, 2.757], [-2.688, -2.757], [2.688, 2.618]],
                        c: false
                    },
                    ix: 2
                },
                nm: 'Path 1',
                mn: 'ADBE Vector Shape - Group',
                hd: false
            }, {
                ty: 'st',
                c: {
                    a: 0,
                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
                    ix: 3
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 4
                },
                w: {
                    a: 0,
                    k: 1,
                    ix: 5
                },
                lc: 2,
                lj: 2,
                nm: 'Stroke 1',
                mn: 'ADBE Vector Graphic - Stroke',
                hd: false
            }, {
                ty: 'fl',
                c: {
                    a: 0,
                    k: [1, 1, 1, 1],
                    ix: 4
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 5
                },
                r: 1,
                nm: 'Fill 1',
                mn: 'ADBE Vector Graphic - Fill',
                hd: false
            }, {
                ty: 'tr',
                p: {
                    a: 0,
                    k: [18.075, 18.625],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 6
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 7
                },
                sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                },
                nm: 'Transform'
            }],
            nm: 'Group 12',
            np: 3,
            cix: 2,
            ix: 12,
            mn: 'ADBE Vector Group',
            hd: false
        }, {
            ty: 'gr',
            it: [{
                ind: 0,
                ty: 'sh',
                ix: 1,
                ks: {
                    a: 0,
                    k: {
                        i: [[1.782, 0], [0, 0], [0, 1.783], [-1.783, 0], [0, 0], [0, -1.783]],
                        o: [[0, 0], [-1.783, 0], [0, -1.783], [0, 0], [1.782, 0], [0, 1.783]],
                        v: [[1.148, 3.227], [-1.147, 3.227], [-4.375, 0], [-1.147, -3.227], [1.148, -3.227], [4.375, 0]],
                        c: true
                    },
                    ix: 2
                },
                nm: 'Path 1',
                mn: 'ADBE Vector Shape - Group',
                hd: false
            }, {
                ty: 'st',
                c: {
                    a: 0,
                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
                    ix: 3
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 4
                },
                w: {
                    a: 0,
                    k: 1,
                    ix: 5
                },
                lc: 2,
                lj: 2,
                nm: 'Stroke 1',
                mn: 'ADBE Vector Graphic - Stroke',
                hd: false
            }, {
                ty: 'fl',
                c: {
                    a: 0,
                    k: [0, 0.458999992819, 0.788000009574, 1],
                    ix: 4
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 5
                },
                r: 1,
                nm: 'Fill 1',
                mn: 'ADBE Vector Graphic - Fill',
                hd: false
            }, {
                ty: 'tr',
                p: {
                    a: 0,
                    k: [11.012, 29.254],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 6
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 7
                },
                sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                },
                nm: 'Transform'
            }],
            nm: 'Group 13',
            np: 3,
            cix: 2,
            ix: 13,
            mn: 'ADBE Vector Group',
            hd: false
        }, {
            ty: 'gr',
            it: [{
                ind: 0,
                ty: 'sh',
                ix: 1,
                ks: {
                    a: 0,
                    k: {
                        i: [[0, 0], [0, 0], [0.47, 0.47], [0.47, -0.47], [0, 0]],
                        o: [[0, 0], [0.47, -0.47], [-0.471, -0.47], [0, 0], [0, 0]],
                        v: [[-1.146, 2.053], [0.786, 0.121], [0.786, -1.583], [-0.919, -1.583], [-1.255, -1.246]],
                        c: false
                    },
                    ix: 2
                },
                nm: 'Path 1',
                mn: 'ADBE Vector Shape - Group',
                hd: false
            }, {
                ty: 'st',
                c: {
                    a: 0,
                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
                    ix: 3
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 4
                },
                w: {
                    a: 0,
                    k: 1,
                    ix: 5
                },
                lc: 2,
                lj: 2,
                nm: 'Stroke 1',
                mn: 'ADBE Vector Graphic - Stroke',
                hd: false
            }, {
                ty: 'tr',
                p: {
                    a: 0,
                    k: [43.655, 21.372],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 6
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 7
                },
                sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                },
                nm: 'Transform'
            }],
            nm: 'Group 14',
            np: 2,
            cix: 2,
            ix: 14,
            mn: 'ADBE Vector Group',
            hd: false
        }, {
            ty: 'gr',
            it: [{
                ind: 0,
                ty: 'sh',
                ix: 1,
                ks: {
                    a: 0,
                    k: {
                        i: [[0, 0], [0, 0], [0, 0], [0, 0]],
                        o: [[0, 0], [0, 0], [0, 0], [0, 0]],
                        v: [[-3.5, -3.365], [-3.5, 3.512], [-0.787, 3.512], [3.5, -3.512]],
                        c: false
                    },
                    ix: 2
                },
                nm: 'Path 1',
                mn: 'ADBE Vector Shape - Group',
                hd: false
            }, {
                ty: 'st',
                c: {
                    a: 0,
                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
                    ix: 3
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 4
                },
                w: {
                    a: 0,
                    k: 1,
                    ix: 5
                },
                lc: 2,
                lj: 2,
                nm: 'Stroke 1',
                mn: 'ADBE Vector Graphic - Stroke',
                hd: false
            }, {
                ty: 'fl',
                c: {
                    a: 0,
                    k: [1, 1, 1, 1],
                    ix: 4
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 5
                },
                r: 1,
                nm: 'Fill 1',
                mn: 'ADBE Vector Graphic - Fill',
                hd: false
            }, {
                ty: 'tr',
                p: {
                    a: 0,
                    k: [18.887, 37.662],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 6
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 7
                },
                sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                },
                nm: 'Transform'
            }],
            nm: 'Group 15',
            np: 3,
            cix: 2,
            ix: 15,
            mn: 'ADBE Vector Group',
            hd: false
        }, {
            ty: 'gr',
            it: [{
                ind: 0,
                ty: 'sh',
                ix: 1,
                ks: {
                    a: 0,
                    k: {
                        i: [[0, 0], [0, 0], [0, 0], [0, 0]],
                        o: [[0, 0], [0, 0], [0, 0], [0, 0]],
                        v: [[-3.064, -3.105], [-3.064, 3.105], [-0.351, 3.105], [3.064, -2.491]],
                        c: false
                    },
                    ix: 2
                },
                nm: 'Path 1',
                mn: 'ADBE Vector Shape - Group',
                hd: false
            }, {
                ty: 'st',
                c: {
                    a: 0,
                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
                    ix: 3
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 4
                },
                w: {
                    a: 0,
                    k: 1,
                    ix: 5
                },
                lc: 2,
                lj: 2,
                nm: 'Stroke 1',
                mn: 'ADBE Vector Graphic - Stroke',
                hd: false
            }, {
                ty: 'fl',
                c: {
                    a: 0,
                    k: [1, 1, 1, 1],
                    ix: 4
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 5
                },
                r: 1,
                nm: 'Fill 1',
                mn: 'ADBE Vector Graphic - Fill',
                hd: false
            }, {
                ty: 'tr',
                p: {
                    a: 0,
                    k: [37.702, 38.069],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 6
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 7
                },
                sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                },
                nm: 'Transform'
            }],
            nm: 'Group 16',
            np: 3,
            cix: 2,
            ix: 16,
            mn: 'ADBE Vector Group',
            hd: false
        }, {
            ty: 'gr',
            it: [{
                ind: 0,
                ty: 'sh',
                ix: 1,
                ks: {
                    a: 0,
                    k: {
                        i: [[5.565, 0], [0, 0], [0, 5.564], [0, 0], [-3.237, 0], [0, 0], [0, -5.565], [0, 0]],
                        o: [[0, 0], [-5.565, 0], [0, 0], [0, -3.237], [0, 0], [5.565, 0], [0, 0], [0, 5.564]],
                        v: [[7.111, 10.077], [-7.111, 10.077], [-17.188, 0.001], [-17.188, -4.215], [-11.326, -10.077], [7.111, -10.077], [17.188, -0.001], [17.188, 0.001]],
                        c: true
                    },
                    ix: 2
                },
                nm: 'Path 1',
                mn: 'ADBE Vector Shape - Group',
                hd: false
            }, {
                ty: 'st',
                c: {
                    a: 0,
                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
                    ix: 3
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 4
                },
                w: {
                    a: 0,
                    k: 1,
                    ix: 5
                },
                lc: 2,
                lj: 2,
                nm: 'Stroke 1',
                mn: 'ADBE Vector Graphic - Stroke',
                hd: false
            }, {
                ty: 'fl',
                c: {
                    a: 0,
                    k: [1, 1, 1, 1],
                    ix: 4
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 5
                },
                r: 1,
                nm: 'Fill 1',
                mn: 'ADBE Vector Graphic - Fill',
                hd: false
            }, {
                ty: 'tr',
                p: {
                    a: 0,
                    k: [26.825, 28.702],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 6
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 7
                },
                sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                },
                nm: 'Transform'
            }],
            nm: 'Group 17',
            np: 3,
            cix: 2,
            ix: 17,
            mn: 'ADBE Vector Group',
            hd: false
        }, {
            ty: 'gr',
            it: [{
                ind: 0,
                ty: 'sh',
                ix: 1,
                ks: {
                    a: 0,
                    k: {
                        i: [[0, 0.377], [1.575, 0.511], [0, 0], [0, 0]],
                        o: [[0, -1.746], [0, 0], [0, 0], [0.099, -0.346]],
                        v: [[1.361, 1.286], [-1.361, -2.432], [-1.361, 2.432], [1.191, 2.367]],
                        c: true
                    },
                    ix: 2
                },
                nm: 'Path 1',
                mn: 'ADBE Vector Shape - Group',
                hd: false
            }, {
                ty: 'st',
                c: {
                    a: 0,
                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
                    ix: 3
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 4
                },
                w: {
                    a: 0,
                    k: 1,
                    ix: 5
                },
                lc: 2,
                lj: 2,
                nm: 'Stroke 1',
                mn: 'ADBE Vector Graphic - Stroke',
                hd: false
            }, {
                ty: 'fl',
                c: {
                    a: 0,
                    k: [0, 0.458999992819, 0.788000009574, 1],
                    ix: 4
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 5
                },
                r: 1,
                nm: 'Fill 1',
                mn: 'ADBE Vector Graphic - Fill',
                hd: false
            }, {
                ty: 'tr',
                p: {
                    a: 0,
                    k: [12.373, 18.625],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 6
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 7
                },
                sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                },
                nm: 'Transform'
            }],
            nm: 'Group 18',
            np: 3,
            cix: 2,
            ix: 18,
            mn: 'ADBE Vector Group',
            hd: false
        }, {
            ty: 'gr',
            it: [{
                ind: 0,
                ty: 'sh',
                ix: 1,
                ks: {
                    a: 0,
                    k: {
                        i: [[0, 0], [0, 0], [0, -2.968]],
                        o: [[0, 0], [2.969, 0], [0, 0]],
                        v: [[-2.688, 2.757], [-2.688, -2.757], [2.688, 2.618]],
                        c: false
                    },
                    ix: 2
                },
                nm: 'Path 1',
                mn: 'ADBE Vector Shape - Group',
                hd: false
            }, {
                ty: 'st',
                c: {
                    a: 0,
                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
                    ix: 3
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 4
                },
                w: {
                    a: 0,
                    k: 1,
                    ix: 5
                },
                lc: 2,
                lj: 2,
                nm: 'Stroke 1',
                mn: 'ADBE Vector Graphic - Stroke',
                hd: false
            }, {
                ty: 'fl',
                c: {
                    a: 0,
                    k: [1, 1, 1, 1],
                    ix: 4
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 5
                },
                r: 1,
                nm: 'Fill 1',
                mn: 'ADBE Vector Graphic - Fill',
                hd: false
            }, {
                ty: 'tr',
                p: {
                    a: 0,
                    k: [13.7, 18.625],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 6
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 7
                },
                sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                },
                nm: 'Transform'
            }],
            nm: 'Group 19',
            np: 3,
            cix: 2,
            ix: 19,
            mn: 'ADBE Vector Group',
            hd: false
        }, {
            ty: 'gr',
            it: [{
                ind: 0,
                ty: 'sh',
                ix: 1,
                ks: {
                    a: 0,
                    k: {
                        i: [[0, 0], [0, 0], [0, 0], [0, 0]],
                        o: [[0, 0], [0, 0], [0, 0], [0, 0]],
                        v: [[-3.5, -3.939], [-3.5, 3.939], [-0.787, 3.939], [3.5, -3.085]],
                        c: false
                    },
                    ix: 2
                },
                nm: 'Path 1',
                mn: 'ADBE Vector Shape - Group',
                hd: false
            }, {
                ty: 'st',
                c: {
                    a: 0,
                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
                    ix: 3
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 4
                },
                w: {
                    a: 0,
                    k: 1,
                    ix: 5
                },
                lc: 2,
                lj: 2,
                nm: 'Stroke 1',
                mn: 'ADBE Vector Graphic - Stroke',
                hd: false
            }, {
                ty: 'fl',
                c: {
                    a: 0,
                    k: [1, 1, 1, 1],
                    ix: 4
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 5
                },
                r: 1,
                nm: 'Fill 1',
                mn: 'ADBE Vector Graphic - Fill',
                hd: false
            }, {
                ty: 'tr',
                p: {
                    a: 0,
                    k: [33.013, 37.235],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 6
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 7
                },
                sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                },
                nm: 'Transform'
            }],
            nm: 'Group 20',
            np: 3,
            cix: 2,
            ix: 20,
            mn: 'ADBE Vector Group',
            hd: false
        }, {
            ty: 'gr',
            it: [{
                ind: 0,
                ty: 'sh',
                ix: 1,
                ks: {
                    a: 0,
                    k: {
                        i: [[0, 0], [0, 0], [0, 0], [0, 0]],
                        o: [[0, 0], [0, 0], [0, 0], [0, 0]],
                        v: [[-3.5, -3.939], [-3.5, 3.939], [-0.787, 3.939], [3.5, -3.085]],
                        c: false
                    },
                    ix: 2
                },
                nm: 'Path 1',
                mn: 'ADBE Vector Shape - Group',
                hd: false
            }, {
                ty: 'st',
                c: {
                    a: 0,
                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
                    ix: 3
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 4
                },
                w: {
                    a: 0,
                    k: 1,
                    ix: 5
                },
                lc: 2,
                lj: 2,
                nm: 'Stroke 1',
                mn: 'ADBE Vector Graphic - Stroke',
                hd: false
            }, {
                ty: 'fl',
                c: {
                    a: 0,
                    k: [1, 1, 1, 1],
                    ix: 4
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 5
                },
                r: 1,
                nm: 'Fill 1',
                mn: 'ADBE Vector Graphic - Fill',
                hd: false
            }, {
                ty: 'tr',
                p: {
                    a: 0,
                    k: [23.637, 37.235],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 6
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 7
                },
                sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                },
                nm: 'Transform'
            }],
            nm: 'Group 21',
            np: 3,
            cix: 2,
            ix: 21,
            mn: 'ADBE Vector Group',
            hd: false
        }, {
            ty: 'gr',
            it: [{
                ind: 0,
                ty: 'sh',
                ix: 1,
                ks: {
                    a: 0,
                    k: {
                        i: [[0, 0], [0, 0], [0, 0], [0, 0]],
                        o: [[0, 0], [0, 0], [0, 0], [0, 0]],
                        v: [[3.125, 1.15], [-3.125, 1.15], [-3.125, -1.15], [3.125, -1.15]],
                        c: true
                    },
                    ix: 2
                },
                nm: 'Path 1',
                mn: 'ADBE Vector Shape - Group',
                hd: false
            }, {
                ty: 'st',
                c: {
                    a: 0,
                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
                    ix: 3
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 4
                },
                w: {
                    a: 0,
                    k: 1,
                    ix: 5
                },
                lc: 2,
                lj: 2,
                nm: 'Stroke 1',
                mn: 'ADBE Vector Graphic - Stroke',
                hd: false
            }, {
                ty: 'fl',
                c: {
                    a: 0,
                    k: [1, 0.773000021542, 0.039000002543, 1],
                    ix: 4
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 5
                },
                r: 1,
                nm: 'Fill 1',
                mn: 'ADBE Vector Graphic - Fill',
                hd: false
            }, {
                ty: 'tr',
                p: {
                    a: 0,
                    k: [40.476, 39.312],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 6
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 7
                },
                sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                },
                nm: 'Transform'
            }],
            nm: 'Group 22',
            np: 3,
            cix: 2,
            ix: 22,
            mn: 'ADBE Vector Group',
            hd: false
        }, {
            ty: 'gr',
            it: [{
                ind: 0,
                ty: 'sh',
                ix: 1,
                ks: {
                    a: 0,
                    k: {
                        i: [[0, -11.907], [11.907, 0], [0, 11.907], [-11.907, 0]],
                        o: [[0, 11.907], [-11.907, 0], [0, -11.907], [11.907, 0]],
                        v: [[21.559, 0], [0.001, 21.559], [-21.559, 0], [0.001, -21.559]],
                        c: true
                    },
                    ix: 2
                },
                nm: 'Path 1',
                mn: 'ADBE Vector Shape - Group',
                hd: false
            }, {
                ty: 'fl',
                c: {
                    a: 0,
                    k: [0.902000038297, 0.902000038297, 0.902000038297, 1],
                    ix: 4
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 5
                },
                r: 1,
                nm: 'Fill 1',
                mn: 'ADBE Vector Graphic - Fill',
                hd: false
            }, {
                ty: 'tr',
                p: {
                    a: 0,
                    k: [25.071, 25.898],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 6
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 7
                },
                sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                },
                nm: 'Transform'
            }],
            nm: 'Group 23',
            np: 2,
            cix: 2,
            ix: 23,
            mn: 'ADBE Vector Group',
            hd: false
        }],
        ip: 0,
        op: 899.000036617021,
        st: 0,
        bm: 0
    }],
    markers: []
};


var AffordableIcon = function AffordableIcon(_ref) {
    var autoplay = _ref.autoplay;


    var AffordableIconContainer = _styledComponents2.default.div(_templateObject);

    var bodymovinOptions = {
        loop: true,
        autoplay: { autoplay: autoplay },
        prerender: true,
        animationData: unfavoritingAnimation
    };

    return _react2.default.createElement(
        AffordableIconContainer,
        null,
        _react2.default.createElement(_reactBodymovin2.default, { options: bodymovinOptions })
    );
};

exports.default = AffordableIcon;


//////////////////
// WEBPACK FOOTER
// ./~/pubweb-react-components/dist/components/Icons/AffordableIcon.js
// module id = 476
// module chunks = 126523225082832